module.exports = __webpack_public_path__ + "media/images/new_culture/approach-full-4511cd051b448cb86e0ce8863daf2d67.png";